import React, { useState } from "react";
import { Card, Container, Button } from "react-bootstrap";
import { GiPsychicWaves } from "react-icons/gi";

const TarotCard = () => {
  const [selectedCardIndex, setSelectedCardIndex] = useState(null);
  // const [cardNumber, setCardNumber] = useState(null);
  const [cardData, setCardData] = useState({});
  const [cardDirection, setCardDirection] = useState("tr");

  // 카드 선택 핸들러
  const handleCardClick = (index) => {
    if (selectedCardIndex !== null) return; // 이미 선택했으면 무시

    const randomNum = Math.floor(Math.random() * 78);
    const randomDirection = Math.random() < 0.5 ? "tr" : "rv";

    const tarotCardList = [{
      "0": {
        "number": 0,
        "name": "The Fool(광대) / 모험",
        "description": "타로 카드의 첫 번째 나오는 것으로써 새로운 출발을 나타 냅니다. 마치 우리가 자신을 알기 위하여 타로를 하듯이, 자신을 발견하기 위하여 여행을 출발하려는 이미지입니다. 젊은이가 절벽의 끝을 막 내딛으려 하고 있습니다. 결과에 무관하게 어떠한 모험을 감수 하여서라도 하고자 하는 그의 의지, 태평스러운 태도를 보여줍니다. 광대는 아주 순진합니다. 그의 배낭에는 아주 적은 재산이 있으며, 왼손에는 순수함을 나타내는 백장미가 있습니다. 세상을 모르는 단순함에도 불구하고, 그는 신의 은총을 받고 있습니다.(등 뒤에 태양이 비추고 있네요) 그는 신성한 아이 이기 때문에, 비록 언덕에서 떨어지더라도 부상당하지 않을 것이라는 느낌이 듭니다. 바로 신의 권능이 그를 돌보고 보호 하기 때문일 것입니다.",
        "true": "순진, 천진난만함, 언제나 신기한 꿈을 추구, 소박함.",
        "reverse": "부주의, 경솔, 단순, 무절제, 사치, 미성숙, 불안정, 불확실함",
        "img": "[00] RWS_Tarot_00_Fool"
      },
      "1": {
        "number": 1,
        "name": "The Magician(마법사) / 창조",
        "description": "타로 카드의 두 번째. 최초로 번호가 붙는 카드입니다. 마법사는 영혼의 세계와 인간 세계와의 다리 역할을 하는 존재입니다. 오른 손에는 하늘로 높이 올려진 지팡이가 있으며, 왼손은 땅을 가리킵니다. 영적인 힘의 전달자이자 신과 인간의 중재자이기도 합니다. 머리에는 영원의 상징이 있으며, 허리에는 자신의 꼬리를 물고 있는 뱀이 있습니다. 마법의 책상에는 모두 4벌의 타로가 있으며 각각은 연금술사 의 근본적인 요소 地(땅-대지), 水(물), 火(불), 風(바람).를 상징하고 있습니다. 당신이 인생의 여행길에서 이러한 마법사를 만났을 때, 당신의 길을 찾을 수 있도록 돕는 훌륭한 현자를 만난 것 입니다. 당신 본성에서의 물질적이고 정신적인 면의 균형을 찾아야 됨을 그는 지시할 것입니다.",
        "true": "독창, 창조, 상상, 자기 확신, 발명의 재주, 융통성, 자기통제, 자제, 극기, 책략.",
        "reverse": "독단, 다재다능하여 성공하지 못함, 창조력 부족, 실패, 기술부족",
        "img": "[01] RWS_Tarot_01_Magician"
      },
      "2": {
        "number": 2,
        "name": "The High Priestess(여성대사제) / 지혜",
        "description": "이 카드는 대립물 들의 결합입니다. 마법사와는 달리 그녀 속에는 이중성을 내포하고 있습니다. 그녀는 두 줄의 사이(하나는 희고, 하나는 검은)에 앉아 있습 니다. 그녀는 우리 모두의 마음 속에 있는 내부적인 영혼의 길잡이 입니다. 여성대사제는 우리들의 무의식, 그리고 오직 어렴풋하게 또는 꿈에서만 우리들에게 진실을 가르쳐 주는 스승을 나타냅니다. 마법사와는 달리 그녀는 자신의 힘을 자랑스럽게 과시하지 않습니다. 오히려 조용하게 때로는 우리들 자신의 '진가를 인정받지 못하는 정신적인 힘'을 나타냅니다. 그녀가 당신 자신에게 묻는 것을 보았을 때, 혹시 내가 간과하는 것이 있는가? 미처 듣지 못했던 내 안에 있는 바라는 표현들이 있는가? 대사제는, 우리들의 문제에 대한 해답, 지도를 위하여 우리들 자신 내부를 깊숙이 들여다 볼 필요성을 지시합니다.",
        "true": "지혜, 건전한 판단력, 무의식 속의 깨달음, 일반적인 상식, 평온과 침착, 객관적인 타당성, 통찰력, 정신적 경향.",
        "reverse": "무지, 연구부족, 비상식적, 결벽증, 자신의 껍질 속에 틀어박힘",
        "img": "[02] RWS_Tarot_02_High_Priestess"
      },
      "3": {
        "number": 3,
        "name": "The Empress(여황제) / 풍요",
        "description": "여황제는 남성이 억제된 여성적 특징, 여성의 원리입니다. 그녀는 무성한 푸른 나뭇잎과 잘 익은 밀밭으로 둘러 쌓여져 있으며, 아마도 임신한 듯한 모습이기도 합니다. 침상 아래에는 심장 모습의 베개가 있습니다. 그녀의 늘어진 겉옷은 비옥을 상징하는 석류나무로 장식되어져 있습니다. 그녀의 뒤에서는 숲속에서 강물이 자유스럽게 흘러갑니다. 여성대사제가 무의식과 영혼을 나타내는 것임에 반하여, 여황제는 대지, 그리고 그것으로부터 생기는 모든 다산과 하사품을 나타냅니다. 그녀의 의미는 부유함, 임무의 완수, 물질적인 필요와 욕구에 대한 만족 등을 암시합니다. 만약 당신이 이 카드를 만났을 때 아마도 당신은 너무나 물질적인 세계에 깊이 빠져 있는 것은 아닐지 한번 생각해 보아야합니다.",
        "true": "비옥함, 여성다운 발전, 성취, 완성, 어머니, 여성의 영향력, 실용적임, 번영, 출산",
        "reverse": "성취하지 못함, 동요, 주저, 태만, 허영심, 제멋대로의 행동, 질투, 달성이 늦어짐, 낭비",
        "img": "[03] RWS_Tarot_03_Empress"
      },
      "4": {
        "number": 4,
        "name": "The Emperor(황제) / 권위",
        "description": "황제는 남성적인 원리, 여성이 억제된 남성적 특징, 가장(家長)등입니다. 권력과 권위를 나타내며, 그의 엄격한 태도는 여황제의 육감적인 아름다움 으로부터 완전히 이탈된 것 입니다. 그의 왕좌 뒤에는 메마른 산(山, 당당한 지배자의 상징)이 있습니다. 그의 오른손은 앙크 십자가(고리 달린 T자형 십자로서 이집트의 생명의 상징)를 잡고 있습니다. 그의 과격한 모습으로 보아, 황제는 냉엄하고 무정하며, 그리하여 심판을 위해서는 오로지 자신의 법과 의견에만 의존할 듯 보입니다. 그가 앉아있는 왕좌도 딱딱하게 보여 부드러움이라고는 찾아볼 수가 없겠습니다. 황제의 강력한 인격으로부터 당신을 무엇을 봅니까? 확고하거나 또는 많은 곤란에도 불구하고 목적 달성과 성공을 암시하는 그의 권능 등이 당신의 내부에 있습니까?",
        "true": "세속적인 힘, 확신, 부유함, 권력, 불굴의 정신, 아버지, 남성의 영향력, 가장(家長)에 해당하는 권위.",
        "reverse": "미숙, 의지박약, 현실인식이 약함, 실무능력 부족, 거만함, 고지식함, 경제적 능력이 없음, 강요",
        "img": "[04] RWS_Tarot_04_Emperor"
      },
      "5": {
        "number": 5,
        "name": "The Hierophant(교황) / 원조",
        "description": "이 카드는 우리 자신과 신의 사이를 연결하는 면에서 마법사 와 비슷합니다. 전통적으로 교황의 역할은 신과 인류의 중재 입니다. 그러한 것으로서, 교황은 신과 만나려할 때 우리를 돕는 영혼의 스승을 나타냅니다. 단순히 방향을 제시하는 마법사와는 달리, 교황은 신뢰받고 있는 안내자이며 우리들을 직접 인도하여 정신적인 목표점으로 이끌어 줄 것입니다. 그는 또한 전통, 정통파를 향상시키기 위한 조직화된 방법 등 을 나타냅니다. 당신이 교황을 만나게 되면, 당신 내면의 정신적인 삶을 점검해 볼 필요가 있습니다. 아마 근원으로 되돌아 가야할 잊어버린 전통을 탐구 할 필요가 있습니다. 또한, 어떠한 믿음에 대해 공통적 표현과는 별도로, 당신 자신의 영혼의 영적인 깊이를 조사해 보아야 할 필요가 있을 것 입니다.",
        "true": "자비와 친절, 신뢰받음, 원조자와의 만남, 공헌, 일을 맡음, 동정심, 용서, 깊은 의미를 깨닫기 위해 노력함.",
        "reverse": "보수주의, 자기 자신의 생각에만 사로잡힘, 신용을 잃음, 고립됨, 시야가 좁음, 오래된 원칙에 집착함",
        "img": "[05] RWS_Tarot_05_Hierophant"
      },
      "6": {
        "number": 6,
        "name": "The Lovers(연인) / 결합",
        "description": "이 카드는 우리 삶에 있어서의 대인관계 - 특히 친밀성 그리고 성적(性的)인 관계를 나타냅니다. 우리 생활에 있어서의 사랑이 기본적으로 어디에서 중요한 것인가의 상황을 나타내며, 그 당시의 대인관계의 상황 등을 반영 합니다. 연인들은 그들 위에 있는 구름 속의 천사들에 의하여 축복받고 보호 받습니다. 또한 태양은 그들의 머리위 에서 따뜻함과 안전을 선사하면서 밝게 빛납니다. 그들이 딛고 있는 땅은 인생이 즐거운 것을 상징하듯이 푸르고 비옥합니다. 이 연인카드는 '아름다움' 그리고 물질적-육체적인 면에 있어서의 '붕괴' 이 양자를 나타냅니다. 당신이 이 카드를 만나면 그들이 당신 삶에 있어서의 조금 더 나은 균형에 대한 필요성을 암시했는지, 아니면 세속적인 실현과 행복을 암시하고 있는지 생각해 보아야 할 것입니다.",
        "true": "사랑과 미(美), 완성과 조화, 결합, 결혼, 깊은 감정과 낙천주의, 감정의 자연스러움, 윤리적, 도덕적.",
        "reverse": "이별, 불만족스런 성관계, 퇴직, 소홀한 사랑, 사랑의 도피행각",
        "img": "[06] RWS_Tarot_06_Lovers"
      },
      "7": {
        "number": 7,
        "name": "The Chariot(전차) / 승리",
        "description": "이 카드에서 전차를 모는 젊은이는 명백한 결심, 초점, 야심의 표정을 가진다. 그는 새로운 경험과 모험을 갈망하는 점에서 첫 번째 카드인 광대와 관련이 있습니다. 그럼에도 불구하고, 그는 초점이 맞추어져 있으며, 또 마음속에 분명한 목적이 있다는 것 때문에 광대와는 다릅니다. 그는 발랄한 정열과 잠재력, 그리고 광대가 가지는 소박, 단순함이 없는 '위대한 목표 완수와 성공을 위한 갈망'을 나타냅니다. 검은 스핑크스는 어떠한 대가를 치루더라도 목표를 달성 하려는 야심찬 욕망 의 부정적인 면이고, 흰 스핑크스는 같은 욕망에 대한 긍정적인 면입니다. 이 카드는 활기차게 목표를 껴안고 그것을 추구할 필요성을 나타내고 있는지를 나타냅니다.",
        "true": "목표를 향한 돌진, 극복된 역경, 성공, 여행, 선공필승, 행동적인 사랑, 지휘자, 활발화 한다.",
        "reverse": "패배, 전의상실, 제자리 걸음, 좌절, 내키지 않음, 능률저하, 벅찬 라이벌의 등장, 소극적",
        "img": "[07] RWS_Tarot_07_Chariot"
      },
      "8": {
        "number": 8,
        "name": "Strength(힘) / 의지",
        "description": "이 카드는 힘(개인의 행위, 행동을 가능하게 하는), 결심, 그리고 전차 카드와 비슷한 방식으로서의 힘(능력의 일반적인 의미)을 나타냅니다. 그러나 그 차이점 들은 분명 합니다. 강렬하고 집중된 전사 대신에, 우리들은 온화한 여인을 만납니다. 그녀는 비무장이며 갑옷의 보호 장구도 갖추지 않았습니다. 그녀는 오직 자신 스스로의 내부로부터 나올 수 있는 조용한 힘으로 사자를 압도합니다. 전차 카드가 외부적인 힘과 의지를 나타내는데, 이 카드는 내부적인 힘과 어떠한 장애물이라도 제거할 인간의 정신적인 힘을 나타냅니다. 그녀의 흰 외투(청결의 상징)에 의하여 정신이 명백한 것을 나타내고, 그녀의 머리 위로 영원성의 상징이 있습니다. 힘 카드를 만나면, 그것은 우리들의 정신적인 삶을 더욱 더 깊게 할 필요가 있다는 지시일 것입니다.",
        "true": "용기와 힘, 확신, 결단력, 도전적인 태도, 배짱, 열성, 불굴의 정신, 불가능을 가능으로 만드는 의지력.",
        "reverse": "겁쟁이, 체념, 실력부족, 인내력부족, 힘의 오용, 잘난척 함, 유혹에 짐.",
        "img": "[08] RWS_Tarot_08_Strength"
      },
      "9": {
        "number": 9,
        "name": "The Hermit(은둔자) / 탐구",
        "description": "은둔자는 현명한 마음의 소유자입니다. 그는 마치 '광대 카드'와 같이 메마른 산꼭대기의 절벽 끝에 서 있습니다.그러나 조심성 없이 그 발끝을 내딛는 천진하고 경험이 없는 광대와는 달리 은둔자는 한 손에 지혜의 지휘봉 을 쥐고 있습니다. 또 다른 손에는 길을 모르는 사람에게 방향을 가르쳐 줄 수 있는 빛을 가지고 있습니다. 은둔자는 어려운 시절에 우리들은 인도하는 선지자(先知者) 이며, 우리가 길을 잃었을 때 우리에게 양심의 소리를 말하는 예언가 입니다. 또 집단적의 무의식의 존재를 통하여 우리 속 에 살고 있는 고대의 인물이면, 그의 빛나는 빛으로 어둠을 꿰뚫고 우리들을 인도하는 우주적인 정신이기도 합니다. 카드를 해석할 때 은둔자를 만난다면, 우리가 찾고 있는 답변은 바로 우리 자신의 마음속에서 찾을 수 있다는 표시로 받아들여야 할 것입니다.",
        "true": "조언, 충고, 사려분별과 신중함, 용의주도 함, 탐구력, 감정을 억제함, 지적방면이 뛰어남.",
        "reverse": "무분별, 융통성이 없음, 집중력부족, 편협함, 경박한 사랑을 함, 경계가 심해 진전되지 않는다.",
        "img": "[09] RWS_Tarot_09_Hermit"
      },
      "10": {
        "number": 10,
        "name": "Wheel of Fortune(운명의 수레바퀴) / 윤회",
        "description": "아마 다른 어떠한 카드보다도 강렬한 이 카드는 밝음과 어둠, 선과 악의 이중적인 면을 가집니다. 이 카드는 돌아 다니는 것은 다시 돌아온다는 문구에서 나타내어지는 것과 같이, 시간의 순환적인 속성, 윤회를 나타냅니다. 우리의 인생은 상승과 하락으로 가득 차 있으며, 어려움과 번영의 시기가 항상 지속되는 것은 없습니다. 우리의 삶은 항상 변화하며 우리들은 우리 삶에 있어서의 변화에 적응하는 것을 배워야 할 것입니다.우리가 이 카드를 만났을 때, 우리가 어떠한 순환의 주기 속에 있는지를 결정 할 수 있도록, 우리들의 삶을 재점검할 기회를 줍니다. 자신이 밑바닥에 있다면, 아마도 자신을 격려하여 앞으로 나아가게 하고, 우리가 상황에 긍정적인 변화를 낳아야 할 필요가 있을 것입니다.",
        "true": "기회 도래, 전환기, 생각지도 않았던 행운, 운명적, 타이밍이 좋음, 유리한 변화, 승진",
        "reverse": "하강기, 때를 잘못 만남, 궁핍함, 불리한 입장이 됨, 실연, 어긋남이 많아짐",
        "img": "[10] RWS_Tarot_10_Wheel_of_Fortune"
      },
      "11": {
        "number": 11,
        "name": "Justice(정의) / 균형",
        "description": "정의 카드는 균형과 조화를 나타냅니다. 모든 카드를 통하여, 우리가 인생의 긍정적·부정적 인 측면을 만났을 때, 우리는 반드시 옳고 그름·어둠과 밝음의 사이에서 선택을 해야 합니다. 이 카드는 건전하고 성취한 인생을 살기 위하여 우리들이 반드시 창조해야 할 균형을 나타냅니다. 이 카드를 만났을 때 이해 되어져야 할 사항은, 당신이 반드시 어떠한 선택을 해야 할 상황은 아니라는 것 입니다. 오히려 당신 인생에 있어서의 '혼란을 대체할 평화'를 가져다 줄 더 많은 중용(中庸)과 평형을 결정하기 위하여, 불균형과 과도한 영역을 돌아다 보아야 한다는 것입니다.",
        "true": "공정함, 균형잡힘, 중립적 입장을 지킴, 조정역할, 조화잡힌 궁합, 합리화 시킴, 분별력, 올바른, 미덕",
        "reverse": "불공평함, 불균형, 불리한 조건, 편파, 선입관, 편견과 독단, 꺼림직한 행동, 도덕을 무시하는 사랑",
        "img": "[11] RWS_Tarot_11_Justice"
      },
      "12": {
        "number": 12,
        "name": "The Hanged Man(매달린 사람) / 희생",
        "description": "매달린 사람은 포로인 것으로 보이며, 알 수 없는 악의적인 힘에 의하여 부당한 처벌을 당하고 있습니다. 이 카드는 독자들에게 재앙 혹은 갈등을 예시하고 있는 듯 하여 편치 못한 마음을 남깁니다. 그렇다고 할지라도, 좀 더 가까이서 본다면 이 카드의 긍정적인 면이 좀 더 분명해 집니다. 젊은이의 표정은 평화스럽고, 알 수 없는 힘의 자비심과 더불어 운명에 만족하고 있는 표정 입니다. 우리가 이 카드를 만나게 되면, 다른 사람들의 혜택을 위하여 또는 우리 자신의 깊은 필요의 완수를 위하여 좀 더 사심 없는 태도로 행동할 필요가 있는 우리 삶의 영역들을 심사숙고해야 합니다. 대조적으로 우리 자신의 정신적이고 영적인 행복을 지나치게 희생시키면서 다른 사람들에게 양보하는 영역이 없는지를 점검할 필요가 있는 것 입니다.",
        "true": "삶에서의 정지 상태, 일시적인 정지, 과도기, 희생, 시련의 시기, 괴로운 체험으로 교훈을 얻는다.",
        "reverse": "열매 맺지 않은 희생, 제멋대로, 필요한 노력을 하지 않는다, 참지 못한다, 이기주의자",
        "img": "[12] RWS_Tarot_12_Hanged_Man"
      },
      "13": {
        "number": 13,
        "name": "Death(죽음) / 종말",
        "description": "아마도 타로 카드 중에서 이 '죽음의 카드'가 가장 두렵고도 사람들에게 잘못 이해되는 것 일 겁니다. 일반적으로 사람들이 지나치게 문자 그대로 받아들이는 경향이 있기 때문입니다. 그렇지만 이 카드는 가장 비옥 하고도 긍정적인 것일 수가 있습니다. 죽음이란, 좀 더 가치 있고 중요한 어떤 것의 시작을 야기시킬, 우리 생활의 '어떠한 국면 또는 변화 단계'의 종말의 암시인 것 입니다. 이 카드를 만난다면, 그것은 깊은 의미와 중요성을 가지는 '풍족하고 성취적인 인생'을 가능하게 하도록 우리생활에 붙어있는 불건전한 부착물 들을 제거할 필요가 있음을 배워야 합니다. \"씨가 땅에 떨어져 죽지 않으면, 열매가 맺히지 않을 것이다\" 이 말은 죽음의 카드가 이해될 때의 문구입니다.",
        "true": "예기치 않은 변화와 손실, 과거 자신에 대한 뜻밖의 변화, 익숙한 상황이나 우정 등의 종결, 계속되는 손해",
        "reverse": "기사회생의 찬스, 슬럼프 탈출, 이미지 체인지, 기적적인 회생, 방침을 180°바꿈, 포기했던 것이 되돌아옴",
        "img": "[13] RWS_Tarot_13_Death"
      },
      "14": {
        "number": 14,
        "name": "Temperance(절제) / 정화",
        "description": "이 카드는 정의 카드와 마찬가지로, 우리 삶의 완성을 성취 하고 경험하기 위한 '균형과 평온함의 필요성'을 나타냅니다. 카드의 이미지에 나오는 천사는 한쪽 발은 돌 위에, 다른 발은 강 위에 있습니다. 이러한 그림에서, 천사는 미지의 환경에 무모하게 뛰어들기 이전에 바닷물을 미리 시험해 보아야 할 필요성 등을 나타내는 것입니다. 이 점에서 그녀는 재고없이 뛰어드는 광대 카드의 변덕 스러운 자유분방함을 완화, 조절하는 것입니다. 절제된 사람이라면 인생에 있어서 대립물들을 혼합하며 극단을 피함으로써 균형을 찾으려 할 것 입니다. 이 카드는 당신 삶에 있어서 더 많은 균형을 찾을 필요가 있음을 나타내고 있는가, 그렇지 않으면 절충과 타협이 필요할 뿐만 아니라, 당신의 선택들에 있어 건전한 것 인가를 가르쳐 주고 있는가를 다시 한 번 되새기게 해줍니다.",
        "true": "중용, 절제, 인내, 자기 통제와 검소한 태도를 통한 목표의 달성, 적응과 조화, 좋은 영향력, 순화",
        "reverse": "절도 없음이 악영향을 가져다옴, 불규칙한 일, 조정능력이 없음, 쓸데없는 일이 많음",
        "img": "[14] RWS_Tarot_14_Temperance"
      },
      "15": {
        "number": 15,
        "name": "Devil(악마) / 속박",
        "description": "악마의 카드는 우리를 기만하여 우리들이 외부적인 힘에 의하여 감금당하고 있다고 생각하게 만드는, 우리를 억제하는 숨겨진 부정적인 힘을 나타냅니다. 악마의 발 아래에 있는 쇠사슬에 묶인 사람들은 '마비적 공포'에 넋을 잃은 상태 입니다. 따라서 여전히 희망이 없으며 무감각한 표정으로 서 있는 것입니다. 그러나 쇠사슬은, 그들의 목에 느슨하게 매달려 있으며, 만약 악마에 의하여 제공된 유혹들에 대한 최면성의 부착물을 제거할 수만 있다면, 자유는 그들의 지배력 안에 있음을 나타냅니다. 악마가 우리들을 둘러 감싸고 있는 쇠사슬 들은 실재하는 것이 아닙니다. 우리는 악마가 우리들을 지배하는 어떠한 힘을 악마에게 준 것 입니다. 카드해석 시 이 악마를 만나게 되면, 자신의 삶에 있어 어느 것에 집착하거나 빠져있는가를 스스로 검토해 보아야 합니다.",
        "true": "속박됨, 타락, 비굴해짐, 욕망의 포로, 황폐한 생활, 밤놀이가 과함, 자신을 속이고 있음",
        "reverse": "구속에서 도망침, 오랜 고뇌에서 해방됨, 나쁜 인연에서 벗어남, 욕심을 버린다, 나쁜 유혹을 뿌리친다.",
        "img": "[15] RWS_Tarot_15_Devil"
      },
      "16": {
        "number": 16,
        "name": "The Tower(탑) / 붕괴",
        "description": "이것은 악마의 카드 다음에 나오는 것으로, 악마의 구속이 깨어지는 것을 나타냅니다. 탑은 감금과 환각의 장소로 볼 수 있으며, 이 건축물의 파괴는 우리 삶의 자유로움을 경험할 수 있도록 합니다. 기만과 야욕, 환각의 탑이 파괴될 때 우리들 은 그릇된 부착물들 없이, 진실과 본체를 맞이할 수 있을 정도로 자유로와질 것입니다. 탑의 급격한 파괴는 갑작스러운 변화, 그리고, 그러한 변화가 사람의 갈피를 잡지 못하게 하는 효과 등을 의미합니다. 그러나 자유스럽고 능력있는 인간이 되기 위해서는, 개인적인 변환 이라는 시련과 심지어는 현상의 급격한 붕괴를 받아 들여야만 합니다. 이 카드는 속박으로부터의 자유에 대한 것 입니다. 악마의 카드가 변화의 필요성을 나타낸다면, 이 탑 카드는 현재의 실질적인 변화를 나타냅니다.",
        "true": "결정적 타격, 분쟁, 트러블 속출, 뜻밖의 사고, 급병, 오래된 신념의 파괴, 대격변을 경험함, 우정의 단절",
        "reverse": "긴박한 상황, 험악한 공기, 내분, 파멸직전, 우쭐대다가 뼈아픈 대가를 받는다, 불운의 상황",
        "img": "[16] RWS_Tarot_16_Tower"
      },
      "17": {
        "number": 17,
        "name": "The Star(별) / 희망",
        "description": "이것은 절제의 카드와 비슷한 조화와 균형의 카드입니다. 그러나 탑의 카드 다음에 등장하기 때문에 이것은 변화와 혼란의 시기가 종료된 것을 나타냅니다. 이것은 성취, 마음의 변화, 정신적, 감정적인 안정의 카드 입니다. 절제의 카드와 마찬가지로, 카드 속의 여인이 두 개의 물병을 가지고 있습니다. 그러나 이 경우, 대지를 비옥하게 하기 위하여 그녀는 물을 쏟아 붓고 있으며, 그녀 주변의 무성한 나무들로 표현되는 비옥함의 순환을 계속 이어나가고 있습니다. 그녀는 경험의 지혜, 고요한 자기 확신, 자기 인식 등을 나타냅니다. 그녀의 지혜 때문에, 고요하게 평화스러운 상태를 유지하는 것입니다. 이 카드는 우리 내부에 있는 길잡이, 그리고 우리가 신성한 영혼의 보호와 인도 아래 있다는 것을 알고 있는 '우리들 본성의 깊숙한 부분'입니다.",
        "true": "소망이 성취됨, 희망에 넘치는 미래, 미적 생활, 아이디어가 떠오름, 상큼한 창조력, 격려가 됨, 밝은 전망",
        "reverse": "걸림, 이상이 너무 높음, 실망함, 좋아하지도 않는 일을 하게 됨, 비관적인 상황, 바램이 너무 높음",
        "img": "[17] RWS_Tarot_17_Star"
      },
      "18": {
        "number": 18,
        "name": "The Moon(달) / 불안",
        "description": "이 카드는 직관, 이상, 그리고 무의식의 카드입니다. 카드의 바닥에 있는 물은 집단적인 무의식의 내부적인 바다 (게와 새우가 나타났네요)를 나타냅니다. 이 생물은, 마치 작은 길목의 시작 부분에서 '개와 늑대'가 우리 마음 속 의 길들여진 것과 같이 야성적인 측면을 나타내듯이, 우리의 마음 깊은 곳으로부터 나타나는 불안한 이미지들을 나타 냅니다. 달은 태양 빛의 반사로써 생기는 불빛을 제공 합니다. 흐릿하고, 불명확하고, 높은 의식의 세계로 여행할 때 우리의 앞길을 희미하게 비춥니다. 하늘에 달이 있을 때는 그야말로, 어둡고 전망이 불투명한 것은 당연한 일입니다. 이 카드는 그것을 말하고 있는 것 입니다. 즉, 애매모호한 주변의 상황을 어떠한 직관적인 힘, 무의식의 힘을 통하여 열어나간다는 뜻입니다.",
        "true": "속임수, 불분명한 주변의 상황, 위험스러운 요소, 나쁜 영향력, 이기주의, 배신, 숨겨진 적",
        "reverse": "위기를 모면함, 조금씩 상황호조, 오해가 풀림, 결심함, 긴 안목으로 봄, 사전에 위험을 알게됨",
        "img": "[18] RWS_Tarot_18_Moon"
      },
      "19": {
        "number": 19,
        "name": "The Sun(태양) / 생명",
        "description": "태양은 낙관주의, 성취, 어두운 밤뒤에 나타나는 새벽의 이미지입니다. 이 땅위의 모든 생명의 근원으로서 태양 카드는 축복과 신성, 생명의 원천 그 자체를 나타냅니다. 즐겁게 놀고 있는 아이는, 우리가 가장 진실된 자기 자신과 조화가 될 때의 내부적 마음의 기쁨을 나타냅니다. 아이가 타고 있는 흰 말은 '힘과 영혼의 순수함'을 나타냅니다. 이 태양 카드는 타로 카드 중 에서 가장 긍정적인 카드 중의 하나 입니다. 따라서 카드 해석 시에 이것을 만났다면, 기쁨과 감사함 으로써 받아들여야 합니다. 이 카드와 관련하여 고려해야 할 부정적인 면이 있다면 무엇일까요? 그것은 우리가 이상에 도달하기 위하여 온갖 난관을 극복했던 것을 잊기 쉽다는 것 입니다. 당신은 기쁨 속에서도 당신이 이미 통과한 많은, 그리고 다른 사람들이 경험하고 있을 시련들을 잊어서는 안 됩니다.",
        "true": "만족, 성취, 성공, 호의적인 대인관계, 기쁨, 헌신적인 사랑, 생명력, 활기참, 건강상태가 좋음, 활발함",
        "reverse": "영속성이 없음, 생산력 저하, 의기소침, 생활불안, 취소됨, 체력부족, 활동력이 쇠약해짐",
        "img": "[19] RWS_Tarot_19_Sun"
      },
      "20": {
        "number": 20,
        "name": "Judgement(심판) / 부활",
        "description": "이 카드는 결정(결단력)의 필요성과 연관이 있습니다. 또한 내부적인 자각, 새로운 삶의 방식의 시작, 세계의 경험 등을 나타냅니다. 이 카드에는 긍정적, 부정적인 두 가지 면이 다 있습니다. 긍정적인 의미에서, 깊은 잠으로부터 깨어나며, 이제서야 정신적인 재탄생과 부활 속에서 통찰력이 우리 위에 나타나기 시작한 것입니다. 부정적인 의미에서, 우리는 과거의 행동을 설명하기 위하여 그리고, 과거에 우리가 해왔던 것들을 정당화 시키기 위하여 소환 되고 있는 중 입니다. 심판은 '계산과 청산의 시기'입니다. 숨겨져 왔던 것들을 가지고 와야 할 시기이기도 합니다. 당신이 이 카드를 만났을 때, 직면해야할 선택과 도전들은 어떠한 것인가, 가장 중요한 것으로서 당신 자신에 대한 스스로의 심판은 무엇 이며, 자신에 대한 값매김은 또 어떠한가를 살펴보아야 할 것입니다.",
        "true": "부활의 기쁨, 운이 열린다, 변혁의 시기, 위기탈출, 결단, 좋은 소식, 재회, 건강회복, 되살아나는 사랑",
        "reverse": "재기불능, 불리한 결정, 채용되지 않음, 나쁜 소식, 연기됨, 결정하지 못함, 헤어짐",
        "img": "[20] RWS_Tarot_20_Judgement"
      },
      "21": {
        "number": 21,
        "name": "The World(세계) / 달성",
        "description": "이 카드는 임무의 완성과 여행의 끝, 순환, 주기의 완료를 나타냅니다. 광대의 여행은 이제 여기에서 끝을 맺습니다. 광대의 지혜와 경험은 이제 완벽한 것입니다. 신약성서의 복음 작가들을 나타내는 네 개의 존재가 이 카드의 구석에 다시 한 번 나타나는데, 그들의 여기에 존재함은 '운명의 수레바퀴 카드'를 상기시킨다. 이 카드는 수레바퀴, 시간의 순환적인 진행과 밀접하게 관련되어 있습니다. 그림속의 여인은 우리들과 함께, 여행이 끝난 것을 기뻐하고 여행의 완료뿐만이 아니라 그것이 약속하는 새로운 시작을 더불어서 축하하고 있습니다. 이 카드는 자각, 기쁨이 가득한 지혜, 그리고 잘못된 부착물의 억압에서 벗어난 자유를 나타냅니다. 우리들은 이제 목적을 달성한 것 입니다.",
        "true": "완성, 성공, 목표달성, 영속성, 전성기, 완벽함, 목적지에 도달함, 정신적 고조, 해피엔드",
        "reverse": "미완성, 계획이 성취되지 않음, 준비 부족으로 인한 실패, 도중하차, 슬럼프에 빠짐, 미숙함",
        "img": "[21] RWS_Tarot_21_World"
      },
      "22": {
        "number": 22,
        "name": "King of Wands",
        "description": "이 카드가 뜻하는 육체적이거나 정서적인 성질은 진한 머리칼이나 피부색, 열정, 유연함, 생기, 감동, 숭고함이다. 지팡이의 왕은 꽃이 핀 지팡이를 세워 들고, 다른 세 지팡이 카드와 마찬가지로 그의 왕관 아래에 보존의 모자라고 불리는 것을 쓰고 있다. 그는 왕좌의 뒤쪽에 장식되어 있는 사자의 기호와 관련되어 있다.",
        "true": "피부색이나 머리카락이 진한 남자, 친근한 사람, 시골 사람, 보통 결혼한 사람, 정직하고 양심적인 사람.",
        "reverse": "선하지만 엄한 사람 엄하지만 관대한 사람.",
        "img": "[22] Wands14"
      },
      "23": {
        "number": 23,
        "name": "Queen of Wands",
        "description": "지팡이 카드들에 그려져 있는 지팡이는 항상 잎사귀가 나있으며, 이것은 지팡이 카드가 생명과 생기를 의미하기 때문이다. 정서적으로 혹은 다른 의미에서, 지팡이 왕비의 인격은 지팡이 왕의 인격과 일치하지만 더 매력적이다.",
        "true": "피부색이나 머리카락이 진한 여자, 시골 여자, 친근한 여자, 순결한 여자, 다정한 여자, 존경스러운 여자. 지팡이 왕비의 옆에 있는 카드가 남자를 의미한다면 이 여자는 남자에게 좋은 감정을 품고 있다 옆에 있는 카드가 여자를 의미한다면 이 여자는 질문자에게 관심이 있다. 또한 금전적인 사랑.",
        "reverse": "선량한 여자, 알뜰한 여자, 잘 돌보아주는 여자, 친절한 여자 또한 반대와 질투, 속임수와 불신을 의미하기도 한다.",
        "img": "[23] Wands13"
      },
      "24": {
        "number": 24,
        "name": "Knight of Wands",
        "description": "그는 마치 여행을 떠나는 길인 것 같으며, 짧은 지팡이를 들고 있고, 갑옷을 입고 있지만 호전적인 목적을 가지고 있지는 않다. 그는 고분이나 피라미드를 지나고 있다.",
        "true": "출발, 부재, 도주, 이주. 피부색이나 머리칼이 진한 젊은 남자, 친근한 남자. 주거지의 변화.",
        "reverse": "파멸, 분열, 중단, 불화.",
        "img": "[24] Wands12"
      },
      "25": {
        "number": 25,
        "name": "Page of Wands",
        "description": "이전의 카드에서 나온 것과 비슷한 장면으로, 한 젊은이가 무언가를 선언하는 듯한 자세로 서 있다. 그는 알려진 인물이 아니지만 믿음직스러우며, 낯선 소식을 전해준다.",
        "true": "피부색이나 머리칼이 진한 젊은 남자, 믿음직한 젊은이, 연인, 사절, 집배원. 남자를 뜻하는 카드의 옆에 나오면, 그 남자에게 유리한 증언을 할 것이다. 컵의 종자(Page of Cups) 카드 다음에 나오면 위험한 경쟁자를 뜻한다. 지팡이 슈트에서 최고의 의미를 지닌다.",
        "reverse": "일화, 발표, 나쁜 소식. 또한 거기에 관련된 우유 부단함과 불안정성.",
        "img": "[25] Wands11"
      },
      "26": {
        "number": 26,
        "name": "Ten of Wands",
        "description": "한 남자가 들고 있는 지팡이 10개의 무게에 짓눌려 있다.",
        "true": "많은 의미를 지닌 카드이며, 어떤 해석은 조화롭게 풀이하지 못할 수 있다. 이 카드를 명예와 좋은 신념에 연결시키는 것은 제쳐둔다. 이 카드는 단순히 압박을 뜻하지만, 행운이나, 획득, 이런 종류의 성공을 뜻하기도 한다. 이것은 또한 그릇된 모습, 위장, 배반의 카드 이기도 하다. 카드의 남자가 가고 있는 장소는 그가 들고 있는 지팡이들 때문에 고통을 받을 지도 모른다. 검의 9(Nine of Swords) 카드가 다음에 나오면 성공은 무효가 되며, 법정 소송에 관한 질문일 경우 어느 정도의 손실을 입을 것이다.",
        "reverse": "반대, 난관, 음모, 그리고 비슷한 것들.",
        "img": "[26] Wands10"
      },
      "27": {
        "number": 27,
        "name": "Nine of Wands",
        "description": "남자는 그의 지팡이에 기대어 서서 뭔가를 기다리고 있다. 그는 마치 적을 기다리고 있는 듯하다. 그의 뒤에는 8개의 다른 지팡이가 마치 울타리처럼 질서 정연하게 서 있다.",
        "true": "이 카드는 대항하는 힘을 뜻한다. 공격당하면 그는 거기에 용감하게 맞설 것이다. 이 주요한 의미와 함께 다른 여러 가지 해석도 포함될 수 있다. 지연, 미결정, 휴회.",
        "reverse": "장애물, 역경, 재난.",
        "img": "[27] Wands09"
      },
      "28": {
        "number": 28,
        "name": "Eight of Wands",
        "description": "이 카드는 고정된 것을 뚫고 지나가는 움직임을 뜻한다. 날아가는 지팡이들이 공개된 땅을 통과하고 있다.",
        "true": "사업에서의 활약, 그런 행동의 방침, 속달 우편 배달부와 같은 신속함 급히 서두름, 큰 희망, 보장된 축복을 약속하는 결말을 향한 빠른 속도의 움직임 또한 사랑의 화살.",
        "reverse": "질투의 화살, 내부의 분쟁, 양심의 가책, 말다툼.",
        "img": "[28] Wands08"
      },
      "29": {
        "number": 29,
        "name": "Seven of Wands",
        "description": "한 젊은이가 높은 언덕에서 지팡이를 휘두르고 있으며, 여섯 개의 다른 지팡이가 아래로부터 그를 향해 들어 올려지고 있다.",
        "true": "이것은 표면적으로 여섯 개가 하나를 공격하고 있지만 젊은이가 유리한 고지를 점유하고 있으므로 용맹을 의미하는 카드이다. 지적인 의미에서 이 카드는 토론, 언쟁을 나타낸다. 사업에서는 협상, 무역 전쟁, 교역, 경쟁을 의미한다. 이것은 더 나아가 성공의 카드인데, 그 이유는 젊은이가 꼭대기에 있고 그의 적들은 아마도 그에게 닿을 수 없기 때문이다.",
        "reverse": "당황함, 곤란함, 걱정.",
        "img": "[29] Wands07"
      },
      "30": {
        "number": 30,
        "name": "Six of Wands",
        "description": "월계관을 쓴 기수가 월계관으로 장식된 지팡이를 들고 있다 지팡이를 든 하인들이 그의 옆에 서 있다.",
        "true": "이 카드는 그 디자인에 따라 여러가지 의미로 해석될 수 있다 표면적으로 이 카드는 승리자를 뜻하지만, 왕의 밀사가 발표하는 매우 좋은 소식을 뜻하기도 한다. 이 카드는 소망의 관, 희망의 관등 을 두르고 있는 기대를 뜻한다.",
        "reverse": "마치 의기양양한 적이 문 앞에 와 있는 듯 한 두려움, 배반, 충실하지 못함, 문이 적에게 열려 있는 것과 같음, 등.",
        "img": "[30] Wands06"
      },
      "31": {
        "number": 31,
        "name": "Five of Wands",
        "description": "젊은이 여러 명이 지팡이를 휘두르고 있으며, 마치 경기 같기도 하고 싸움 같기도 하다. 이것은 전쟁을 모방한 것이다.",
        "true": "가짜 싸움과 같은 모방, 부와 재산을 향한 격렬한 경쟁과 투쟁. 그래서 어떤 의미로는 금전, 이득, 부유함의 카드라고도 한다.",
        "reverse": "소송, 논쟁, 속임수, 모순.",
        "img": "[31] Wands05"
      },
      "32": {
        "number": 32,
        "name": "Four of Wands",
        "description": "네 개의 커다란 지팡이가 땅에 세워져 있고 그 위에 거대한 화환이 올려져 있다 두 여인이 작은 꽃다발을 위로 들고 있다. 옆에는 해자 위의 다리는 옛날 영주의 집으로 향하고 있다.",
        "true": "한 때 표면적인 의미만 있었다. 전원생활, 휴식, 일치, 조화, 번영, 평화, 그리고 이런 것들의 완벽한 결과.",
        "reverse": "의미는 변하지 않는다. 번영, 이익, 경사, 미, 꾸밈.",
        "img": "[32] Wands04"
      },
      "33": {
        "number": 33,
        "name": "Three of Wands",
        "description": "조용하고 위엄 있는 사람이 등을 돌린 채로 벼랑 끝에 서서 바다 위로 지나가는 배들을 지켜보고 있다. 세 개의 지팡이가 땅에 꽂혀 있으며, 그는 그 중 하나에 몸을 살짝 기대고 있다.",
        "true": "그는 자리를 잡은 힘, 사업, 노력, 거래, 통상, 발견 등을 상징한다. 지나가고 있는 배들은 그의 것이며, 바다를 건너갈 그의 상품을 싣고 있다.",
        "reverse": "문제의 종결, 역경이나 수고 실망의 중지나 종결.",
        "img": "[33] Wands03"
      },
      "34": {
        "number": 34,
        "name": "Two of Wands",
        "description": "키가 큰 남자가 총안이 있는 성벽의 지붕 위에서 바다와 해변을 바라보고 있다 그는 오른 손에 지구본을, 왼손에 지팡이를 들고 성벽에 기대어 있다 다른 하나의 지팡이는 고리로 고정되어 있다. 왼편에 있는 장미와 십자가, 백합을 빼놓지 말라.",
        "true": "여러 가지 가능한 해석 중에 한꺼번에 나오는 것은 없다. 한편으로는 부, 행운, 장엄함, 다른 한 편으로는 육체적인 고통, 질병, 억울함, 슬픔, 고행. 그림의 구성은 다음과 같은 의미를 제시한다. 그의 지배지역을 돌아보는 군주가 있으며, 그는 또한 세계에 대해 생각하고 있다. 이것은 세상에 있는 장엄한 부의 한 복판에 있는 알렉산더의 질병, 굴욕, 슬픔을 나타내는 듯하다.",
        "reverse": "놀람, 경이, 매혹, 감동, 근심, 두려움.",
        "img": "[34] Wands02"
      },
      "35": {
        "number": 35,
        "name": "Ace of Wands",
        "description": "구름에서 뻗어 나온 손이 튼튼한 지팡이를 쥐고 있다.",
        "true": "창조, 발명, 사업, 이런 것들을 만들어 내는 힘 원리, 시작, 원천 탄생, 가족, 기원 사업의 시작 다른 해석에 따르면, 금전, 부, 상속.",
        "reverse": "추락, 타락, 파멸, 죽음, 멸망 또한 맑지 않은 기쁨.",
        "img": "[35] Wands01"
      },
      "36": {
        "number": 36,
        "name": "King of Cups",
        "description": "그는 짧은 지휘봉을 왼손에 들고 커다란 컵을 오른손에 들고 있다 그의 왕좌는 바다 위에 자리 잡고 있다. 한 편에서는 배가 떠 있으며 다른 한 편에서는 돌고래가 뛰어 오르고 있다. 함축적인 의미로 컵의 기호는 자연스럽게 모든 왕실 카드에 등장하는 물을 뜻하고 있다.",
        "true": "피부색이나 머리칼이 밝은 남자, 사업가, 법률가, 사제 책임 있고 질문자에게 도움을 주려는 남자 또한 공평, 예술과 과학, 과학이나 법률과 예술의 전문가 창조적인 지능인.",
        "reverse": "불성실, 이중적인 남자 사기, 강요, 부정, 악덕, 추문.",
        "img": "[36] Cups14"
      },
      "37": {
        "number": 37,
        "name": "Queen of Cups",
        "description": "아름답고 피부색과 머리칼이 밝으며 꿈꾸는 듯이 컵 안에서 환상을 보는 듯 한 여자.",
        "true": "선하고 피부색과 머리칼이 맑은 여자가 질문자에게 도움을 줄 것이다 정답고 영리함, 그리고 상상의 선물 성공, 행복, 기쁨 또한 지혜, 미덕.",
        "reverse": "해석은 다양하다 착한 여자, 다른 뜻으로 뛰어 나지만 신용할 수 없는 여자 파고드는 여자 악덕, 수치, 타락.",
        "img": "[37] Cups13"
      },
      "38": {
        "number": 38,
        "name": "Knight of Cups",
        "description": "품위 있지만 도전적이지는 않은 조용히 말을 타고 있으며, 종종 이 카드의 특징이 되는 상상의 세련미를 뜻하는 날개 달린 투구를 쓰고 있다.",
        "true": "도착, 가끔은 전달자의 도착 진보, 제안, 행실, 초대, 자극.",
        "reverse": "속임수, 책략, 음흉함, 사취, 표리부동, 기만.",
        "img": "[38] Cups12"
      },
      "39": {
        "number": 39,
        "name": "Page of Cups",
        "description": "밝은 머리칼과 피부색의 유쾌하고 약간은 나약한 소년이 근면하고 성실한 모습으로 컵에서 나와 자신을 보는 물고기를 응시하고 있다.",
        "true": "밝은 머리칼과 피부색의 젊은이, 억지로 봉사를 하게 되며 질문자와 관계를 맺는 남자 면학에 힘쓰는 젊은이 소식, 전갈 몰두, 숙고, 명상 또한 사업의 방향으로 향하게 된 이런 측면들.",
        "reverse": "취미, 기호, 애착, 매혹, 속임수, 책략.",
        "img": "[39] Cups11"
      },
      "40": {
        "number": 40,
        "name": "Ten of Cups",
        "description": "무지개 속에서 컵들이 나타난다. 아래에서는 경외와 환희에 찬 남녀가 무지개를 바라보고 있으며, 그 둘은 분명히 부부인 것 같다. 남자의 오른팔은 여자를 감싸고 있으며, 왼팔은 위를 향해 들고 있다 여자는 오른팔을 들고 있다. 그들 주변에서 춤추고 있는 두 어린아이는 아직 그 경이로운 광경을 보지 못했지만, 그들 나름대로 행복해하고 있다. 뒤에는 집의 모습이 보인다.",
        "true": "만족, 감정의 완전한 휴식, 완벽한 상태, 여러개의 그림 카드와 함께 나온다면, 질문자의 이익을 담당 하고 있는 사람 또한 질문자가 머무르고 있는 마을.",
        "reverse": "잘못된 마음의 평온, 분개, 폭력.",
        "img": "[40] Cups10"
      },
      "41": {
        "number": 41,
        "name": "Nine of Cups",
        "description": "용모가 단정한 인사가 만족스럽게 잔치를 즐기고 있으며 풍부하고 신선한 포도주가 그의 뒤에 있는 아치형의 단에 늘어서 있다.",
        "true": "화합, 만족, 육체적인 풍요 또한 승리, 성공, 이득 질문자나 조언을 구하는 사람의 만족.",
        "reverse": "진실, 충실, 자유 하지만 해석은 다양하고 실수나, 불완전함 등도 포함된다.",
        "img": "[41] Cups09"
      },
      "42": {
        "number": 42,
        "name": "Eight of Cups",
        "description": "낙심한 듯한 남자가 그에게 주어진 경사, 기획(사업계획), 인수받은 사업, 또는 이전 관심 의 컵들을 버리고 건다",
        "true": "표면적으로는 카드 스스로 이야기를 해 주지만, 다른 해석은 완전히 대조적이다. 기쁨을 줌, 온화함, 소심함, 명예, 중용.",
        "reverse": "커다란 기쁨, 행복, 연회.",
        "img": "[42] Cups08"
      },
      "43": {
        "number": 43,
        "name": "Seven of Cups",
        "description": "이상한 상상의 성배들.",
        "true": "우아한 풍미, 묵상과 정서와 상상의 이미지, 명상의 잔에서 보이는 것들 이 정도에서 약간은 이룰 수 있지만 영원하거나 실체적인 것은 없다.",
        "reverse": "욕망, 의지, 결단, 계획.",
        "img": "[43] Cups07"
      },
      "44": {
        "number": 44,
        "name": "Six of Cups",
        "description": "오래된 정원의 아이들, 그들의 컵은 꽃으로 가득 차 있다.",
        "true": "과거와 추억의 카드, 회상, 예를 들어서 어린 시절에 대한 회상 행복, 즐거움, 하지만 다소 오랜 기억으로부터 오는 것 사라진 것들. 다른해석은 이것과 반대로 새로운 관계의 성립, 새로운 지식, 새로운 환경, 그리고 아이들이 새로 들어온 구역에서 즐겁게 놀고 있다고 한다.",
        "reverse": "미래, 부흥, 얼마 안 있어 지나갈 것들.",
        "img": "[44] Cups06"
      },
      "45": {
        "number": 45,
        "name": "Five of Cups",
        "description": "진한 머리칼의 망토를 두른 사람이 세 개의 넘어진 잔을 옆으로 보고 있다 다른 두 개의 잔이 그의 뒤에 똑바로 서 있다 뒤에는 작은 성이나 요새로 향하는 다리가 있다.",
        "true": "이것은 상실의 카드이나 뭔가가 뒤에 남겨져 있다 3개는 빼앗겼지만 2개는 남아 있다 이것은 상속, 세습, 전달의 카드이지만 기대에 부응하지는 않는다. 어떤 때는 결혼의 카드이기도 하지만 쓰라림이나 좌절이 없지는 않다.",
        "reverse": "소식, 동맹, 호감, 친족 관계, 조상, 귀환, 잘못된 계획.",
        "img": "[45] Cups05"
      },
      "46": {
        "number": 46,
        "name": "Four of Cups",
        "description": "한 젊은이가 나무 아래에 앉아서 앞의 잔디 위에 놓인 세 개의 컵을 응시하고 있다. 구름으로부터 나온 팔이 다른 하나의 컵을 그에게 권하고 있다. 그럼에도 그가 표현하고 있는 것은 주변 환경에 대한 불만이다.",
        "true": "피로, 혐오, 역경, 가공의 원통함, 마치 이 세상의 포도주가 포만감만을 주는 것과 같음 다른 포도주는 마치 요정의 선물과 같이 이제 그에게 주어지지만 그는 거기에서 위로를 얻지 못한다. 이것은 또한 뒤섞인 기쁨을 뜻하기도 한다.",
        "reverse": "",
        "img": "[46] Cups04"
      },
      "47": {
        "number": 47,
        "name": "Three of Cups",
        "description": "처녀들이 정원에서 컵을 위로 올린 채로 마치 서로에게 맹세하는 듯이 기대어 있다.",
        "true": "풍요로움, 완전함, 즐거움 등의 측면에서의 결과 행복한 주제, 승리, 완결, 위안, 치유.",
        "reverse": "원정, 특파, 성취, 종결.",
        "img": "[47] Cups03"
      },
      "48": {
        "number": 48,
        "name": "Two of Cups",
        "description": "젊은 남녀가 서로 기대어 있고, 그들의 컵 위로 헤르메스의 지팡이가 솟아나오며, 그 커다란 날개 사이에서 사자의 머리가 나타나 있다. 이것은 이 카드의 오래된 모델 중 한 가지의 변종이다. 여기에는 약간 진기한 의미가 더해져 있지만, 여기에서는 상관이 없다.",
        "true": "사랑, 열정, 우정, 단합, 일치, 동정, 이성간의 상호 관계, 그리고 다른 예언방식과는 다른 의미로 그 본성이 신성한 것들.",
        "reverse": "거짓 사랑, 어리석음, 오해.",
        "img": "[48] Cups02"
      },
      "49": {
        "number": 49,
        "name": "Ace of Cups",
        "description": "아래에 물이 있고 그 위에 백합이 떠 있다 구름에서 나온 손은 손바닥 위로 컵을 들고 있으며, 컵에서부터 다섯 개의 물줄기가 흘러내린다. 부리에 십자가 무늬가 그려진 성찬식 빵을 물고 있는 비둘기 한 마리가 컵 안의 물을 향해 내려오고 있다 모든 방향으로 물방울이 떨어지고 있다. 이것은 마이너 아카나 뒤에 숨겨져 있을지도 모르는 것들에 대한 묘사이다.",
        "true": "진정한 애정 속의 가정과 기쁨, 만족, 어도비 벽돌, 자양물, 풍요로움, 비옥함, 신성한 탁자, 여기에 관한 경사.",
        "reverse": "그릇된 애정 속의 가정, 돌연변이, 불안정, 대변혁.",
        "img": "[49] Cups01"
      },
      "50": {
        "number": 50,
        "name": "King of Swords",
        "description": "검의 왕은 이 슈트의 상징, 즉 칼집에서 꺼낸 검을 들고 판단을 내리고 있다.",
        "true": "판단과 거기에 관련된 모든 것들로부터 떠오르는 생각 즉, 권력, 명령, 권위, 투쟁적인 지성, 법, 왕의 임무 등.",
        "reverse": "잔인함, 괴팍함, 잔인함, 불성실, 사악한 의도.",
        "img": "[50] Swords14"
      },
      "51": {
        "number": 51,
        "name": "Queen of Swords",
        "description": "왕비의 오른 손은 검을 수직으로 들고 있으며 검 자루는 그녀의 왕좌 한쪽 팔걸이에 올려져 있다. 그녀는 팔을 들어 올려 왼손을 뻗고 있다 그녀의 표정은 엄한 동시에 누그러져 있으며, 슬픔과 친밀함을 알 수 있게 해준다.",
        "true": "과부 신세, 여성의 슬픔 과 당혹스러움, 방심, 불임, 애도, 결핍, 분리.",
        "reverse": "악의, 완고함, 책략, 얌전한 체 함, 사기.",
        "img": "[51] Swords13"
      },
      "52": {
        "number": 52,
        "name": "Knight of Swords",
        "description": "그는 마치 적들을 산산이 흩뜨려놓을 듯이 전속력으로 달리고 있다.",
        "true": "기능, 용기, 재능, 방어, 솜씨, 적의, 분노, 전쟁, 파괴, 반대, 저항, 파멸.",
        "reverse": "경솔함, 무능력, 낭비.",
        "img": "[52] Swords12"
      },
      "53": {
        "number": 53,
        "name": "Page of Swords",
        "description": "유연하고 활동적인 소년이 검을 양손으로 세워 든 채로 재빠르게 걷고 있다.",
        "true": "권위, 감독, 비밀 임무, 경계, 염탐, 시험 그리고 거기에 속한 성질들.",
        "reverse": "이런 성질의 더 악한 측면 예측되지 않고 준비 되지 않은 상황 질병도 암시하고 있다.",
        "img": "[53] Swords11"
      },
      "54": {
        "number": 54,
        "name": "Ten of Swords",
        "description": "카드에 그려져 있는 검에 찔린 사람이 엎드려 있다.",
        "true": "그림에 의해 제시되는 어떤 것이라도 가능하다 또한 고통, 고민, 비탄, 슬픔, 고독.",
        "reverse": "장점, 이익, 성공, 호의, 하지만 이것들 중의 어느 것도 영원하지는 않다 또한 권력과 권위.",
        "img": "[54] Swords10"
      },
      "55": {
        "number": 55,
        "name": "Nine of Swords",
        "description": "여자가 침상에서 비탄에 빠져 있고, 그 위로 검들이 걸려 있다.",
        "true": "죽음, 실패, 과오, 지연, 기만, 실망, 절망.",
        "reverse": "감금, 의심, 적절한 공포를 의심함, 수치.",
        "img": "[55] Swords09"
      },
      "56": {
        "number": 56,
        "name": "Eight of Swords",
        "description": "한 여자가 묶이고 눈이 가린 채로 검에 둘러싸여 있다.",
        "true": "나쁜 소식, 폭력에 의한 억울함, 위기, 비난, 구속된 힘, 갈등, 중상 또한 질병.",
        "reverse": "동요, 역경, 반대, 사고, 배반 예측하지 못한 것 참사.",
        "img": "[56] Swords08"
      },
      "57": {
        "number": 57,
        "name": "Seven of Swords",
        "description": "한 남자가 다섯 자루의 검을 급하게 어디론가 옮겨가고 있다. 다른 두 자루의 검은 땅에 꽂혀 있다. 야영지가 바로 근처에 있다.",
        "true": "착상, 시도, 소원, 희망, 신임 또한 말다툼, 실패할 것으로 보이는 계획, 성가심.",
        "reverse": "좋은 충고, 조언, 가르침, 욕설, 수다.",
        "img": "[57] Swords07"
      },
      "58": {
        "number": 58,
        "name": "Six of Swords",
        "description": "사공이 그의 나룻배에 여행객을 태우고 먼 강가로 저어 가고 있다.",
        "true": "물을 통한 여행, 노정, 길, 사절, 임명, 수단.",
        "reverse": "선언, 자백, 공공성 어떤 해석에서는 이것을 사랑 고백이라고도 한다.",
        "img": "[58] Swords06"
      },
      "59": {
        "number": 59,
        "name": "Five of Swords",
        "description": "한 남자가 의기양양한 표정으로 낙담하여 도망가는 둘을 바라보고 있다. 그들의 검 두 자루는 땅에 놓여 있다. 그는 두 자루의 다른 검을 왼쪽 어깨에 지고서 세 번째 검을 땅으로 향한 채 들고 있다. 그는 이 땅을 소유한 주인이다.",
        "true": "좌천, 파괴, 반전, 불명예, 수치, 상실.",
        "reverse": "정위치와 같은 뜻 매장, 장례식.",
        "img": "[59] Swords05"
      },
      "60": {
        "number": 60,
        "name": "Four of Swords",
        "description": "기도하는 자세의 기사의 모습이 그의 무덤 위에 있다.",
        "true": "경계, 은퇴, 고독, 은둔자의 휴식, 추방, 무덤과 관.",
        "reverse": "현명한 운영, 용의주도함, 절약, 탐욕, 조심, 유언.",
        "img": "[60] Swords04"
      },
      "61": {
        "number": 61,
        "name": "Three of Swords",
        "description": "세 자루의 검이 하트를 찌르고 있다 그 뒤로는 구름과 비가 보인다.",
        "true": "제거, 부재, 지연, 분리, 파괴, 분산, 그리고 이 그림이 자연스럽게 보여주는 모든 의미.",
        "reverse": "정신적 소외감, 실책, 상실, 혼란, 무질서, 혼동.",
        "img": "[61] Swords03"
      },
      "62": {
        "number": 62,
        "name": "Two of Swords",
        "description": "눈을 가린 사람이 두 자루의 검을 그의 양어깨에 기대고 있다.",
        "true": "적합성과 균형을 보여주며, 두 팔의 모습처럼 용기와 우정을 뜻한다. 애정, 친밀함.",
        "reverse": "사기, 거짓말, 표리부동, 불충실함.",
        "img": "[62] Swords02"
      },
      "63": {
        "number": 63,
        "name": "Ace of Swords",
        "description": "구름에서 손이 뻗어 나와 검을 쥐고 있으며 그 끝은 왕관으로 둘러싸여 있다.",
        "true": "승리, 모든 방면에서 정도가 지나침, 정복, 무력의 승리. 이것은 증오뿐만 아니라 사랑의 거대한 힘을 의미하는 카드이다.",
        "reverse": "정위치와 동일하나 결과가 더 비참하다. 다른 뜻으로는 구상, 분만, 증가, 다양성이 있다.",
        "img": "[63] Swords01"
      },
      "64": {
        "number": 64,
        "name": "King of Pentacles",
        "description": "이 그림은 특별한 설명이 필요하지 않다 왕의 얼굴은 다소 어두워서 용기를 암시하기도 하지만 무기력한 경향을 비치고 있다. 그의 왕좌에 여러 번 등장하는 황소의 머리도 살펴봐야 한다. 이 슈트의 기호가 오각별 모양으로 새기거나 그려져 있으며, 이것은 인간 본성의 네 가지 원소가 조화를 이루고 본성에 의해 그것들이 조절됨을 보여준다.",
        "true": "용맹, 지성을 실현함, 사업과 일반적인 지성적 태도, 때로는 수학적인 재능과 이런 종류의 획득 이런 방면에서의 성공.",
        "reverse": "악덕, 약함, 흉측함, 괴팍함, 타락, 위험.",
        "img": "[64] Pents14"
      },
      "65": {
        "number": 65,
        "name": "Queen of Pentacles",
        "description": "왕비의 얼굴은 어두운 피부색을 하고 있다. 그녀의 자질은 위대한 영혼의 생각으로 집약될 수 있을 것이다 그녀는 또한 매우 지성적인 기질도 가지고 있다 그녀는 자신의 상징물을 바라보며 그 안에 있는 세계를 보고 있을 것이다.",
        "true": "부유함, 관대함, 장엄함, 안전, 자유.",
        "reverse": "악, 의심, 불안, 공포, 불신.",
        "img": "[65] Pents13"
      },
      "66": {
        "number": 66,
        "name": "Knight of Pentacles",
        "description": "그는 느리고 참을성 있는 큰 말에 타고 있으며, 이 말은 그의 특성과 잘 부합된다.",
        "true": "유용성, 실용성, 이득, 책임, 청렴함.",
        "reverse": "무기력, 게으름, 그런 종류의 휴식, 정체 또한 허약함, 낙담, 부주의.",
        "img": "[66] Pents12"
      },
      "67": {
        "number": 67,
        "name": "Page of Pentacles",
        "description": "한 젊은이가 치켜든 손위로 떠 있는 오각별을 주의 깊게 바라보고 있다.",
        "true": "응용, 학문 습득, 몰두 다른 뜻으로는 소식, 전갈과 그 전달자 또한 규칙, 관리.",
        "reverse": "낭비, 소실, 관대함, 사치 안 좋은 소식.",
        "img": "[67] Pents11"
      },
      "68": {
        "number": 68,
        "name": "Ten of Pentacles",
        "description": "남자와 여자가 그들의 집과 영지를 향해 뚫려 있는 입구의 아치 아래에 서 있다.",
        "true": "획득, 부 가족의 일, 기록 보관소, 혈통, 가족의 보금자리.",
        "reverse": "기회, 참사, 상실, 강탈, 위험한 유희 때로는 선물, 지참금, 연금.",
        "img": "[68] Pents10"
      },
      "69": {
        "number": 69,
        "name": "Nine of Pentacles",
        "description": "손목에 새를 올려놓은 여인이 커다란 집의 정원에서 풍요로운 포도나무 가운데에 서 있다.",
        "true": "신중함, 안전, 성공, 성취, 확신, 식별.",
        "reverse": "사기, 기만, 최소화된 계획, 그릇된 신념.",
        "img": "[69] Pents09"
      },
      "70": {
        "number": 70,
        "name": "Eight of Pentacles",
        "description": "예술가가 돌을 가지고 작업하고 있다.",
        "true": "일, 고용, 임명, 장인정신, 공예와 사업, 그에 따른 준비단계.",
        "reverse": "버려진 야망, 허영심, 탐욕, 강제 징수, 고리 대금.",
        "img": "[70] Pents08"
      },
      "71": {
        "number": 71,
        "name": "Seven of Pentacles",
        "description": "한 젊은이가 지팡이에 기대어 서서 오른쪽에 있는 푸른 나무덤불에 붙어 있는 일곱 개의 오각별을 물끄러미 바라보고 있다. 이것은 그의 보물이며 그의 마음은 거기에 가 있다고 할 수 있다.",
        "true": "이 카드의 의미들은 서로 지극히 모순적이다. 주로 이 카드는 돈, 사업, 교역의 뜻을 지니지만 반대로 언쟁, 말다툼의 뜻도 있다 그리고 다른뜻으로는 순수함, 독창력, 정화라는 의미도 있다.",
        "reverse": "돈에 대한 걱정.",
        "img": "[71] Pents07"
      },
      "72": {
        "number": 72,
        "name": "Six of Pentacles",
        "description": "상인의 복장을 한 사람이 한 쌍의 저울로 돈을 재어서 가난한 사람들에게 나누어주고 있다.",
        "true": "선물, 은혜, 만족시키기 다른 의미로는 주의, 경계 이제는 받아들여지는 시간, 현재의 번영, 등등.",
        "reverse": "욕망, 탐욕, 시기, 질투, 환상.",
        "img": "[72] Pents06"
      },
      "73": {
        "number": 73,
        "name": "Five of Pentacles",
        "description": "두 거지가 눈보라 속에서 불이 켜진 창문 아래를 지나고 있다.",
        "true": "이 카드는 무엇보다도 물질적인 곤경을 뜻한다. 그 형태가 그림에 그려진 궁핍의 형태일 수도 있고 아닐 수 도 있다. 어떤 점술가에게 이 카드는 사랑과 연인 즉, 아내와 남편, 친구, 애인을 뜻한다. 또한 일치와 애정을 의미하기도 한다. 이런 해석은 서로 섞이면 안 된다.",
        "reverse": "무질서, 혼란, 파멸, 불화, 난봉.",
        "img": "[73] Pents05"
      },
      "74": {
        "number": 74,
        "name": "Four of Pentacles",
        "description": "관을 쓴 남자가 머리 위에 오각별을 지고 또 하나의 오각별을 손과 팔로 꼭 쥐고 있다. 두 개의 오각별은 그의 발 아래에 있다.",
        "true": "소유의 보증, 가진 것에 대한 집착, 선물, 유산, 상속.",
        "reverse": "불안, 지연, 대립.",
        "img": "[74] Pents04"
      },
      "75": {
        "number": 75,
        "name": "Three of Pentacles",
        "description": "조각가가 수도원에서 일을 하고 있다.",
        "true": "거래, 교역, 숙련된 노동 그러나 보통은 귀족과 상위 계층, 명성과 영광의 카드이다.",
        "reverse": "일에서의 평범함, 혹은 유치함, 시시함, 허약함.",
        "img": "[75] Pents03"
      },
      "76": {
        "number": 76,
        "name": "Two of Pentacles",
        "description": "한 젊은이가 양손에 오각별을 하나씩 들고 춤을 추고 있으며, 그 두 오각별은 넘어진 8 모양의 끝없는 줄로 연결 되어있다.",
        "true": "한편으로는 이 그림의 주제대로 유쾌함, 오락과 거기에 관련된 의미를 지는 카드이지만, 다른 편으로는 문서로 된 소식과 전갈, 장애물, 동요, 고민, 혼란의 뜻도 있다.",
        "reverse": "강요된 잔치, 가장된 즐거움, 문자 상의 의미, 필적, 구성, 교환 편지.",
        "img": "[76] Pents02"
      },
      "77": {
        "number": 77,
        "name": "Ace of Pentacles",
        "description": "여느 때처럼 구름에서 손이 나와 오각별을 들고 있다.",
        "true": "완벽한 만족, 경사, 환희: 또한 재빠른 지성 금전.",
        "reverse": "부의 악한 측면, 나쁜 지성 또한 막대한 부.",
        "img": "[77] Pents01"
      }
    }]
    const selectedCard = tarotCardList[0][randomNum];

    // setCardNumber(randomNum);
    setCardData(selectedCard);
    setCardDirection(randomDirection);
    setSelectedCardIndex(index);
  };

  const handleReset = () => {
    setSelectedCardIndex(null);
    setCardData({});
    setCardDirection("tr");
  };

  return (
    <div className="saju-wrapper">
      <Container>
        <div className="saju-card-container text-center">
          <h2 className="mb-3 d-flex align-items-center justify-content-center gap-2 fw-bold text-warning">
            <GiPsychicWaves /> 타로 카드
          </h2>
          <p className="text-muted small mb-4">
            신중하게 마음을 가다듬고 아래의 6장 카드 중 운명의 카드 한 장을 선택하세요.
          </p>

          {/* 타로 카드 리스트 */}
          <div className="d-flex justify-content-center flex-wrap mt-4">
            {[...Array(6)].map((_, index) => (
              <div
                key={index}
                className={`tarot-3d-wrapper ${
                  selectedCardIndex === null
                    ? ""
                    : selectedCardIndex === index
                      ? "selected"
                      : "unselected"
                }`}
                onClick={() => handleCardClick(index)}
              >
                <div className={`tarot-card-inner ${selectedCardIndex === index ? "flipped" : ""}`}>
                  {/* 카드 뒷면 (앞쪽을 향함) */}
                  <div className="tarot-face tarot-face-front">
                    <img
                      src={`${process.env.PUBLIC_URL}/tarotimg/tarotback.jpg`}
                      alt="타로카드 뒷면"
                      className="tarot-img"
                    />
                  </div>
                  {/* 카드 앞면 (뒤집혔을 때 보여짐) */}
                  <div className="tarot-face tarot-face-back">
                    {selectedCardIndex === index && cardData.img ? (
                      <img
                        src={`${process.env.PUBLIC_URL}/tarotimg/${cardDirection}/${cardData.img}.jpg`}
                        alt={cardData.name}
                        className="tarot-img"
                      />
                    ) : (
                      <div className="w-100 h-100 bg-dark"></div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* 타로 점괘 결과 카드 */}
          {selectedCardIndex !== null && cardData.name && (
            <Card className="mt-5 p-4 text-center tarot-report-card fade-in-text">
              <Card.Body className="p-0">
                <div className="tarot-report-title mb-2">
                  🔮 {cardData.name}
                </div>
                <div className={`tarot-direction-badge ${cardDirection}`}>
                  {cardDirection === "tr" ? "정위치 (Right-side up)" : "역위치 (Reversed)"}
                </div>
                <div className="tarot-report-desc">
                  {cardData.description}
                </div>
                <div className="tarot-interpretation-box mb-4">
                  <div className="tarot-interpretation">
                    <strong className="text-warning">카드 해석: </strong> 
                    {cardDirection === "tr" ? cardData.true : cardData.reverse}
                  </div>
                </div>
                <div>
                  <Button className="tarot-btn-primary px-4 py-2" onClick={handleReset}>
                    다시 고르기 (카드 재셔플)
                  </Button>
                </div>
              </Card.Body>
            </Card>
          )}
        </div>
      </Container>
    </div>
  );
};

export { TarotCard };
